//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  MenuItem,
} from '@mui/material';
import {
  SpaceDashboard,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import { Spacer } from 'components/Spacer';
import { LayoutPresets } from 'pages/FileViewer/components/LayoutSavePreset/LayoutSavePreset';

// === HOOKS ===

//#endregion

//-----------------------------------------------------------------
export function MenuItemLayoutPreset(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { handleClose } = props;

  const theme = useTheme();

  const [ is_open, setIsOpen ] = useState(false);
  
  //#endregion
  
  //#region [STYLES]

  const _anchor_settings = { anchorName: `--save_layout_menu` };
  const _flex_display = { display: 'flex' };

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick( event ) {
    //-----------------------------------------------------------------
    event.stopPropagation();
    event.preventDefault();

    setIsOpen( true );
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    // prevent Menu from overriding dialog's keydown event
    if( is_open ) event.stopPropagation();
  }

  //-----------------------------------------------------------------
  function onDialogClose( event ) {
    //-----------------------------------------------------------------
    setIsOpen( false );
    handleClose()
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <MenuItem sx={{ padding: '4px' }} onKeyDown={onKeyDown}>
        <Styled styles={[_flex_display, _anchor_settings, { alignItems:'center'}, { cursor: 'pointer' } ]} onClick={onClick}>
          <SpaceDashboard /> <Spacer size={4} /> Layout Presets
        </Styled>
        <LayoutPresets is_open={is_open} onClose={onDialogClose}/>
      </MenuItem>
    )
  }

  //#endregion

  return display();
}
